import { render } from "./BasicSettings.vue?vue&type=template&id=e4b89066"
import script from "./BasicSettings.vue?vue&type=script&lang=js"
export * from "./BasicSettings.vue?vue&type=script&lang=js"

import "./BasicSettings.vue?vue&type=style&index=0&id=e4b89066&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__